var _path, _polygon, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAigLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 199.2 108",
    viewBox: "0 0 199.2 108",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "aigLogo",
    d: "M51.5,40.5l9,20.6H42.1L51.5,40.5z M49.9,23.8L21.7,84.3h9.9l6.8-14.7h25.9l6.2,14.7h10L53.4,23.8H49.9z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "aigLogo",
    points: "99.2 84.3 90.1 84.3 90.1 23.8 99.2 23.8 99.2 80.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "aigLogo",
    d: "m147.1 52.9h25v2c0 4.6-0.5 8.6-1.6 12.1-1 3.2-2.8 6.3-5.3 9.1-5.6 6.3-12.8 9.5-21.4 9.5-8.5 0-15.7-3.1-21.7-9.2-6-6.2-9.1-13.5-9.1-22 0-8.8 3.1-16.3 9.2-22.3 6.2-6.2 13.6-9.2 22.4-9.2 4.7 0 9.2 1 13.3 2.9 3.9 1.9 7.8 5.1 11.6 9.4l-6.5 6.2c-5-6.6-11-9.9-18.2-9.9-6.4 0-11.8 2.2-16.1 6.6-4.3 4.3-6.5 9.8-6.5 16.3 0 6.8 2.4 12.3 7.3 16.7 4.5 4.1 9.4 6.1 14.7 6.1 4.5 0 8.5-1.5 12.1-4.5 3.6-3.1 5.6-6.7 6-11h-15.1l-0.1-8.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "aigLogo",
    d: "M8.3,8.5H191v91.1H8.3V8.5z M0,107.9h199.2V0.2H0V107.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAigLogo);
export default __webpack_public_path__ + "static/media/aig-logo.295f39e630d77d656723c8f7d43bf898.svg";
export { ForwardRef as ReactComponent };